import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const DollarSign = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function DollarSign({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.25 5.25V3.5C11.25 3.22386 11.4739 3 11.75 3H12.25C12.5261 3 12.75 3.22386 12.75 3.5V5.25H16C16.2761 5.25 16.5 5.47386 16.5 5.75V6.25C16.5 6.52614 16.2761 6.75 16 6.75H12.75V11.25H14C16.0711 11.25 17.75 12.9289 17.75 15C17.75 17.0711 16.0711 18.75 14 18.75H12.75V20.5C12.75 20.7761 12.5261 21 12.25 21H11.75C11.4739 21 11.25 20.7761 11.25 20.5V18.75H7.5C7.22386 18.75 7 18.5261 7 18.25V17.75C7 17.4739 7.22386 17.25 7.5 17.25H11.25V12.75H10C7.92893 12.75 6.25 11.0711 6.25 9C6.25 6.92893 7.92893 5.25 10 5.25H11.25ZM11.25 6.75H10C8.75736 6.75 7.75 7.75736 7.75 9C7.75 10.2426 8.75736 11.25 10 11.25H11.25V6.75ZM12.75 12.75V17.25H14C15.2426 17.25 16.25 16.2426 16.25 15C16.25 13.7574 15.2426 12.75 14 12.75H12.75Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'dollar-sign-icon-svg'} iconRender={iconRender} {...props} />;
});

export default DollarSign;
